import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../Styles/Openings.css";

const Openings = () => {
  const [jobs, setJobs] = useState([]);
  const [visibleCount, setVisibleCount] = useState(6);
  const [filters, setFilters] = useState({
    search: "",
    type: "",
    location: "",
    category: "",
    salaryRange: "",
    title: "",
  });

  // useEffect(() => {
  //   const fetchJobs = async () => {
  //     try {
  //       const response = await fetch(
  //         "/prosapiens-cms/public/api/careers"
  //       );
  //       const data = await response.json();
  //       if (data?.content) {
  //         setJobs(data.content);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching job data:", error);
  //     }
  //   };
  //   fetchJobs();
  // }, []);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(
          "/prosapiens-cms/public/api/careers"
        );
        const data = await response.json();
        if (data?.content) {
          // Sort jobs by latest first
          const sortedJobs = [...data.content].sort((a, b) => {
            // If API gives created_at field (use this)
            if (a.created_at && b.created_at) {
              return new Date(b.created_at) - new Date(a.created_at);
            }
            // Else fallback to id (higher id = latest)
            return b.id - a.id;
          });

          setJobs(sortedJobs);
        }
      } catch (error) {
        console.error("Error fetching job data:", error);
      }
    };
    fetchJobs();
  }, []);

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
    setVisibleCount(6);
  };

  const filteredJobs = jobs.filter((job) => {
    const matchesSearch = job.job_title
      .toLowerCase()
      .includes(filters.search.toLowerCase());
    const matchesType =
      filters.type === "" || job.job_type_name === filters.type;
    const matchesLocation =
      filters.location === "" || job.location_name === filters.location;
    const matchesCategory =
      filters.category === "" || job.job_category_name === filters.category;
    const matchesSalary =
      filters.salaryRange === "" ||
      job.salary_range_text === filters.salaryRange;
    const matchesTitle =
      filters.title === "" || job.role_name === filters.title;

    return (
      matchesSearch &&
      matchesType &&
      matchesLocation &&
      matchesCategory &&
      matchesSalary &&
      matchesTitle
    );
  });

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 6);
  };

  return (
    <div className="openings-section">
      <section className="opeings-Desktop-Banner jobseeker-review-mobile">
        <div className="overlay container">
          <div className="hero-text">
            <h1>Explore Job Openings</h1>
            <p style={{ color: "#fff" }}>
              Explore expert articles, thought leadership, and actionable tips
              on hiring, HR innovation, remote work, and building
              high-performance teams. Stay ahead of the curve with ProSapiens.
            </p>
          </div>
        </div>
      </section>

      <section className="job-openings-container">
        {/* Filters */}
        <div className="filters filter-wrapper">
          <input
            type="text"
            name="search"
            placeholder="Search"
            value={filters.search}
            onChange={handleChange}
          />

          <select
            name="category"
            value={filters.category}
            onChange={handleChange}
          >
            <option value="">All Job Category</option>
            {[...new Set(jobs.map((job) => job.job_category_name))].map(
              (cat, i) => (
                <option key={i} value={cat}>
                  {cat}
                </option>
              )
            )}
          </select>

          <select name="title" value={filters.title} onChange={handleChange}>
            <option value="">All Roles</option>
            {[...new Set(jobs.map((job) => job.role_name))].map((title, i) => (
              <option key={i} value={title}>
                {title}
              </option>
            ))}
          </select>

          <select name="type" value={filters.type} onChange={handleChange}>
            <option value="">All Job Type</option>
            {[...new Set(jobs.map((job) => job.job_type_name))].map(
              (type, i) => (
                <option key={i} value={type}>
                  {type}
                </option>
              )
            )}
          </select>

          <select
            name="location"
            value={filters.location}
            onChange={handleChange}
          >
            <option value="">All Locations</option>
            {[...new Set(jobs.map((job) => job.location_name))].map(
              (loc, i) => (
                <option key={i} value={loc}>
                  {loc}
                </option>
              )
            )}
          </select>

          <select
            name="salaryRange"
            value={filters.salaryRange}
            onChange={handleChange}
          >
            <option value="">All Salary Range</option>
            {[
              ...new Set(
                jobs.map((job) => job.salary_range_text).filter(Boolean)
              ),
            ].map((salary, i) => (
              <option key={i} value={salary}>
                {salary}
              </option>
            ))}
          </select>
        </div>

        {/* Jobs List */}
        <div className="jobs-container">
          {filteredJobs.length === 0 ? (
            <div className="no-openings" style={{ textAlign: "center" }}>
              🚫 No Openings Available
            </div>
          ) : (
            <>
              <div className="jobs-grid">
                {filteredJobs.slice(0, visibleCount).map((job) => (
                  <div className="testimonial-card" key={job.id}>
                    <div className="testimonial-header">
                      <div className="user-info">
                        <h3>{job.job_title}</h3>
                        {/* <p className="designation">{job.location_name}</p> */}
                      </div>
                    </div>

                    <div className="job-details">
                      <div className="detail-item">
                        <i className="fa fa-briefcase"></i>{" "}
                        {job.job_type_name || "Full Time"}
                      </div>
                      <div className="detail-item">
                        <i className="fa fa-map-marker"></i> {job.location_name}
                      </div>
                      {job.experience && (
                        <div className="detail-item">
                          Experience: {job.experience} years
                        </div>
                      )}
                    </div>

                    <div
                      className="testimonial-content"
                      dangerouslySetInnerHTML={{ __html: job.job_text }}
                    />

                    <Link to={`/job-details/${job.id}`} className="cta-button">
                      More Details →
                    </Link>
                  </div>
                ))}
              </div>

              {visibleCount < filteredJobs.length && (
                <div className="load-more-wrapper">
                  <button className="load-more-btn" onClick={handleLoadMore}>
                    Load More
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default Openings;
